import Commons from '../shared/libraries/commons';
import { BaseSerializer } from '/src/app/core/serializers/baseSerializer';
import constants from '@core/utils/constants';

class TransactionSerializer extends BaseSerializer {
  deserialize(raw, isLatestTransations) {
    const serverRes = raw.data || raw.error;
    const success = serverRes.statusCode == 200 || serverRes.statusCode == 404;
    if (success) {
      return {
        statuCode: 200,
        success: true,
        message: 'List got',
        data: /* transactions || */ (serverRes?.data || []).map(formatTrx)
      };
    }
    return {
      statusCode: serverRes.statusCode || raw.status || 500,
      success: false,
      message:
        (serverRes.message || 'Erreur lors de la récupération') +
        ` Code d'erreur: TRX_ERR_${
          serverRes.statusCode || raw.status || '1000'
        }`,
      data: null
    };
  }

  serialize() {}

  deserializeTransactoinDetail(raw) {
    const serverRes = raw.data || raw.error;
    const success = serverRes.statusCode == 200 || serverRes.statusCode == 404;
    if (!success) {
      return {
        statusCode: serverRes.statusCode || raw.status || 500,
        success: false,
        message:
          (serverRes.message || 'Erreur lors de la récupération') +
          ` Code d'erreur: TRX_ERR_${
            serverRes.statusCode || raw.status || '1000'
          }`,
        data: null
      };
    }

    return {
      statuCode: 200,
      success: true,
      message: 'Found',
      data: formatTrx(serverRes.data)
    };
  }
}

function formatTrx(trx) {
  // trx = {
  //   id: '7d7bb5a2-258f-4672-89ec-c51b521be623',
  //   country: 'BJ',
  //   createdAt: '2025-12-22T15:08:07.966Z',
  //   dst: {
  //     requestId: '47e31d84-3260-4de0-bcc4-9b6e5a5e362c',
  //     amount: 54540,
  //     phoneNumber: '90909090',
  //     userId: 'hoa0buxrdhudmeslck8tgqm48builf',
  //     firstName: 'John',
  //     lastName: 'Doe'
  //   },
  //   dstStatus: 'pending',
  //   email: 'test@gmail.com',
  //   firstName: 'John',
  //   lastName: 'Doe',
  //   metadata: {},
  //   src: {
  //     type: 'withdrawal',
  //     bookmaker: '1xbet',
  //     operationId: '210414c6-9e06-4e4b-908f-c847a617c0d9',
  //     playerId: '410915221',
  //     withdrawalCode: '90909090',
  //     service: '{lacasaeBettingServiceName}',
  //     currency: 'xof',
  //     orchestratorId: '1cf3b552-27d0-4a30-8616-a5d9f760ff08',
  //     amount: 54540
  //   },
  //   srcStatus: 'pending',
  //   status: 'created',
  //   updatedAt: '2025-12-22T15:08:08.051Z',
  //   userId: 'hoa0buxrdhudmeslck8tgqm48builf'
  // };

  const serviceId = trx.metadata?.trxService;
  const serviceInfo = constants.TRANSACTIONS.SERVICES_LIST.find(
    (s) => s.id === serviceId
  );
  const serviceName = serviceInfo?.name || serviceId || 'Service';
  const serviceLogo = serviceInfo?.logo || '';

  const operation = trx.metadata?.trxServiceOperation;
  const operationData = constants.TRANSACTIONS.SERVICES_OPTIONS[
    serviceId
  ]?.find((o) => o.id === operation);

  const operationName = operationData?.title || '-';

  return {
    /** Identité */
    id: trx.id,
    bookmakerId: trx.src?.playerId || trx.bookmakerId,
    service: serviceId,
    bookmaker: trx.src?.bookmaker || trx.bookmaker,
    operation,

    /** Affichage */
    logo: serviceLogo,
    operationNameDisplay: operationName,

    /** Dates */
    startDate: Commons.time(trx.createdAt, 'DD MMM YYYY - HH:mm'),
    createdAt: trx.createdAt,

    /** Montants */
    amountToSend: trx.src?.amount,
    currencyToSend: trx.src?.currency?.toUpperCase() || 'XOF',

    amountToReceive: trx.dst?.amount,
    currencyToReceive: 'XOF',

    fee: trx.metadata?.amounts?.fee,
    feeCurrency: 'XOF',

    earning: trx.metadata?.amounts?.earning,
    bonus: trx.metadata?.amounts?.bonus,

    /** Détail des frais */
    feeBreakdown: {
      // srcServiceFee: trx.metadata?.amounts?.srcAmount,
      // dstServiceFee: trx.metadata?.amounts?.dstAmount,
      // srcProcessorFee: 0,
      // dstProcessorFee: 0,
      earning: trx.metadata?.amounts?.earning,
      bonus: trx.metadata?.amounts?.bonus
    },

    status: trx.status || 'unknown',
    statusDisplay: statusDisplay?.[trx.status] || 'Inconnu',
    statusDetailed: statusDetailed?.[trx.status] || null,

    collectStatus: trx.srcStatus || 'unknown',
    collectStatusDisplay: statusDisplay?.[trx.srcStatus] || 'Inconnu',
    collectStatusDetailed: statusDetailed?.[trx.srcStatus] || null,

    depositStatus: trx.dstStatus || 'unknown',
    depositStatusDisplay: statusDisplay?.[trx.dstStatus] || 'Inconnu',
    depositStatusDetailed: statusDetailed?.[trx.dstStatus] || null,

    /** Utilisateur */
    senderFirstName: trx.firstName,
    senderLastName: trx.lastName,
    senderEmail: trx.email,
    senderPhoneNumber: trx.metadata?.phoneNumber || trx.dst?.phoneNumber,
    senderCountryCode: trx.country,

    /** Paiement */
    paymentMethod: trx.metadata?.paymentMethod,
    senderPhoneNumberUsed: trx.metadata?.senderPhoneNumber,
    recipientPhoneNumber: trx.dst?.phoneNumber,

    /** Métadonnées utiles */
    operationDetails: getOperationDetail({ ...trx, operation }),

    /** Brut pour vue détail */
    rawData: trx
  };
}

function getOperationDetail(trx) {
  const serviceId = trx.src?.service || trx.service;
  const serviceInfo = constants.TRANSACTIONS.SERVICES_LIST.find(
    (s) => s.id === serviceId
  );

  const serviceName = serviceInfo?.name || serviceId || 'Service';
  const serviceLogo = serviceInfo?.logo || '';

  if (trx.operation == 'fund') {
    return {
      collectName: 'Paiement',
      depositName: `Dépot ${serviceName}`,
      paymentMethod: trx.paymentMethod,
      service: serviceId,
      serviceName,
      serviceLogo,
      bookmaker: trx.src?.bookmaker || trx.bookmaker
    };
  }
  if (trx.operation == 'withdraw') {
    return {
      collectName: `Retrait ${serviceName}`,
      depositName: `Dépost sur ${serviceName}`,
      paymentMethod: trx.paymentMethod,
      service: serviceId,
      serviceName,
      serviceLogo,
      bookmaker: trx.src?.bookmaker || trx.bookmaker
    };
  }
}

const statusGroup = {
  error: 'error',
  failed: 'error',
  created: 'pending',
  pending: 'pending',
  lockedInPending: 'pending',
  success: 'success',
  paid: 'success',
  refunded: 'error',
  unpaid: 'pending',
  collected: 'pending',
  paidFailed: 'pending'
};

const statusDisplay = {
  success: 'Réussi',
  paid: 'Réussi',
  validated: 'Réussi',
  error: 'Échouée',
  failed: 'Échouée',
  created: 'Créé',
  pending: 'En cours',
  unpaid: 'Dépot en cours',
  refunded: 'Remboursé',
  collected: 'En cours',
  paidFailed: 'En cours',
  funding_failed: 'Echec de dépot',
  not_subscribed: 'Abonnement échoué',
  transaction_timeout: 'Transaction expirée sans confirmation du paiement',
  transaction_failed: "Le paiement n'a pas été confirmé",
  failed_amount_missmatch:
    "Le montant entre votre transaction et l'opérateur sont différent",
  merchant_balance_is_low: 'Erreur',
  subscriber_balance_is_low: 'Le solde du compte est insuffisant',
  not_enough_money: 'Pas assez de fonds sur le wallet Kingrecharge',
  min_amount_error: 'Le montant entré est inférieur au minimum autorisé',
  failed_to_launch_collect: "Echec d'initiation de la récupération de fond",
  failed_to_launch_deposit: "Echec d'initiation du depot",
  bad_transaction_data: 'Les données de la transaction ne sont pas correcte',
  bad_otp_code: "Le code otp entré n'est pas correct",
  same_operation_in_short_period:
    'Une transaction avec les même données a été lancée récement. Veuillez patienter puis relancer dans quelqeus minutes'
};

const statusDetailed = {
  success: 'Transaction effectué avec succès',
  paid: 'Transaction effectué avec succès',
  validated: 'Transaction effectué avec succès',

  error: 'L’opération a échoué',
  failed: 'L’opération a échoué',

  created: 'Transaction initiée et en attente de traitement',
  pending: 'Transaction en cours de traitement',

  unpaid: 'Dépôt initié, en attente de confirmation',
  refunded: 'Montant remboursé au client',

  collected: 'Paiement réussi, confirmation en attente',
  paidFailed: 'Paiement réussi, confirmation en attente',

  funding_failed: 'Échec lors de la tentative de dépôt',
  not_subscribed: 'Échec : l’abonnement n’a pas été activé',

  transaction_timeout:
    'La transaction a expiré faute de confirmation du paiement',
  transaction_failed: 'Le paiement n’a pas pu être confirmé',

  failed_amount_missmatch:
    'Incohérence détectée : le montant envoyé ne correspond pas à celui de l’opérateur',

  merchant_balance_is_low: 'Solde insuffisant sur le compte marchand',
  subscriber_balance_is_low: 'Solde insuffisant sur le compte utilisateur',

  not_enough_money: 'Fonds insuffisants sur le wallet',

  min_amount_error: 'Le montant saisi est inférieur au minimum autorisé',

  failed_to_launch_collect:
    'Impossible d’initier la demande de collecte de fonds',
  failed_to_launch_deposit: 'Impossible d’initier la demande de dépôt',

  bad_transaction_data:
    'Les informations fournies pour la transaction sont incorrectes ou incomplètes',

  bad_otp_code: 'Le code OTP saisi est invalide. Veuillez réessayer.',

  same_operation_in_short_period:
    'Une opération similaire a été effectuée récemment. Merci de patienter quelques minutes avant de réessayer.'
};

const operationNameDisplay = {
  wallet_funding: 'Recharge de wallet',
  send_money_option1: 'Envoi d’argent',
  send_money_option2: 'Envoi d’argent',
  ask_money: 'Demande d’argent',
  buy_airtime: 'Achat de crédit',
  buy_databundle: "Achat d'internet",
  buy_carrierbundle: 'Achat de forfait',
  buy_giftcard: 'Achat de carte cadeau',
  buy_bank_card: 'Achat de carte bancaire',
  buy_physical_bank_card: 'Achat de carte bancaire',
  fund_physical_bank_card: 'Recharge de carte bancaire',
  pay_fundraise: 'Paiement pour cagnotte',
  unknown: 'Inconnu'
};

export const serializer = new TransactionSerializer();
